module.exports = __webpack_public_path__ + "assets/img/picture1.038f81e0.svg";